import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { AlertTriangle } from "lucide-react";

// Backup che contiene anni eliminati: scelta esplicita
export const ImportDeletedYearsDialog = ({ conflict, onChoose, onCancel }) => (
  <Dialog open={!!conflict} onOpenChange={(o) => !o && onCancel()}>
    <DialogContent data-testid="import-deleted-years-dialog" className="sm:max-w-xl">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2"><AlertTriangle size={18} className="text-amber-600" /> Il backup contiene anni eliminati</DialogTitle>
        <DialogDescription>
          Anni eliminati presenti nel file: <strong data-testid="import-deleted-years-list">{conflict?.years.join(", ")}</strong>. Vuoi escluderli o reintrodurli?
        </DialogDescription>
      </DialogHeader>
      <DialogFooter className="gap-2 flex-wrap">
        <Button variant="outline" onClick={onCancel}>Annulla import</Button>
        <Button variant="outline" data-testid="import-restore-deleted" onClick={() => onChoose("restore")}>Reintroduci anche questi anni</Button>
        <Button data-testid="import-skip-deleted" onClick={() => onChoose("skip")}>Importa escludendoli</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
